export default __webpack_public_path__ + "images/mela-purchase/reviews/dummy-parent-87f475d46edf4768702ec7defd697b1b.png";